import { compareAsc, compareDesc } from "date-fns";

import { createAppSelector } from "./base";
import { Capability, hasSectionCapability, selectCurrentUserRole } from "./permissions";

import { RootState } from "store";
import { AIContextItem } from "store/slices/ai.ts";

export const selectAiChatMessages = createAppSelector(
  [(state) => state.ai.aiChatMessages],
  (aiChatMessages) =>
    Object.values(aiChatMessages).toSorted((a, b) => {
      // Put system messages before other messages and sort by createdAt.
      if (a.role === "system" && b.role !== "system") return -1;
      if (a.role !== "system" && b.role === "system") return 1;
      return compareDesc(b.createdAt, a.createdAt);
    }),
);

export const selectContextMessages = createAppSelector(
  [(state) => state.ai.contextItems],
  (contextItems): AIContextItem[] => {
    const contextMessages: AIContextItem[] = Object.values(contextItems || {});
    return contextMessages.toSorted((a, b) => {
      return b.role.localeCompare(a.role) || compareAsc(b.id, a.id);
    });
  },
);

export const selectContextFiles = createAppSelector(
  [(state) => state.ai.contextFiles],
  (contextFiles) =>
    Object.values(contextFiles || {}).toSorted((a, b) => b.url.localeCompare(a.url)),
);

export const selectToolNames = (state: RootState) => state.ai.tools;

export const selectIsAiDebuggerVisible = (state: RootState) => state.ai.aiDebuggerVisible;

export const selectIsAssessWithAIModeEnabled = createAppSelector(
  [(state) => state.ai.assessWithAIMode, selectCurrentUserRole],
  (assessWithAIMode, userRole) =>
    assessWithAIMode && hasSectionCapability(userRole, Capability.CAN_AUTHOR_SECTION),
);

export const selectIsStudentResponsesForAIEnabled = (state: RootState) =>
  state.ai.isStudentResponsesForAIEnabled;

export const selectUserSelectedAIModel = (state: RootState) => state.ai.userSelectedAIModel;
